import React, { useEffect, useState } from 'react';
import Img from 'common/components/tags/img/Img';
import Input from 'common/components/tags/inputs/Input';
import style from './Style.module.css';
import { useWindowSize } from 'usehooks-ts';
import IntroductingBanner from 'common/components/banners/Introduction-Banner';
import clsx from 'clsx';
import { isEmpty, notEmpty } from 'common/utils/methods';
import { debounceTime } from 'common/utils/constants';
import useHttp from 'common/hooks/useHttp';
import Overlay from 'common/components/UI/overlay';
import Link from 'common/components/tags/link';

let lockRequest = false;
const Banner = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { width } = useWindowSize();
  const [searchKey, setSearchKey] = useState('');
  const [searchList, setSearchList] = useState<Category[]>([]);
  const [isOpenSearchList, setIsOpenSearchList] = useState<boolean>(false);
  const { sendRequest } = useHttp();

  useEffect(() => {
    if (isEmpty(searchKey)) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [searchKey]);

  useEffect(() => {
    const time = setTimeout(() => {
      if (lockRequest && notEmpty(searchKey)) {
        fetch();
      }
    }, debounceTime);
    return () => {
      clearTimeout(time);
    };
  }, [searchKey]);

  const fetch = async () => {
    sendRequest(
      { url: `/posts?categoryType=faq&searchKey=` + searchKey },
      onSuccess
    );
  };
  const onSuccess = (res: Responsive) => {
    setLoading(false);
    setIsOpenSearchList(true);
    setSearchList(res.data.items);
  };

  const handleChange = (e: MyInputEvent) => {
    lockRequest = true;
    setSearchKey(e.target.value);
  };

  const onClear = () => {
    setIsOpenSearchList(false);
    setSearchKey('');
  };

  return (
    <section className='container'>
      <Overlay
        active={isOpenSearchList}
        onClick={() => setIsOpenSearchList(false)}
      />
      <div className='relative'>
        <div
          className={`section-space-t before:contents-[""] after:contents-[""] relative h-[13rem] overflow-hidden rounded-4 bg-primary px-[1.8rem]
      pt-[2.6rem] text-center before:absolute before:bottom-[5rem] before:left-[-5rem] before:h-[13.1rem]
          
      before:w-[13.1rem] before:rounded-full before:bg-white before:opacity-10
      after:absolute after:top-[53%] after:right-[-15%] after:h-[13.1rem] after:w-[13.1rem] after:rounded-full after:bg-white after:opacity-10 sm:after:top-[44%]
      sm:after:right-[-10%] md:h-[13.6rem] 

      md:rounded-[2.1rem] md:pt-[4.5rem] md:before:h-[18.3rem] md:before:w-[18.3rem] 
      md:after:h-[18.3rem] md:after:w-[18.3rem] xl:h-[22.5rem] xl:rounded-[3.6rem] xl:pt-[6rem] xl:before:bottom-[25%] xl:before:left-[-7%] xl:before:h-[30rem] xl:before:w-[30rem] xl:after:top-[46%] xl:after:right-[-6%]
      xl:after:h-[30rem] xl:after:w-[30rem] 

     
      `}
        >
          <Img
            src='/img/star-white.svg'
            alt='star-white'
            className='absolute top-[4rem] left-[3rem] h-[1.8rem] w-[1.8rem] md:top-[1rem] md:left-[14rem]
          md:h-[2.4rem] md:w-[2.4rem] xl:top-[2rem] xl:left-[19rem]  xl:h-[3.9rem] xl:w-[3.9rem]
                  '
          />
          <Img
            src='/img/star-outline.svg'
            alt='star-outline'
            className='absolute top-[6.5rem] left-[4rem] h-[1.3rem] w-[1.3rem] md:top-[4rem] md:left-[15.5rem]
          md:h-[1.8rem] md:w-[1.8rem] xl:top-[6rem] xl:left-[22rem] xl:h-[2.9rem] xl:w-[2.9rem] '
          />
          <h1
            className={clsx(
              `inline-block text-[2rem] font-bold text-white md:text-[2.5rem] xl:text-[4.2rem]`,
              style['shape']
            )}
          >
            how can we help you?
          </h1>

          <div className={style['line1']}></div>
          {width > 768 && (
            <>
              <div
                className='absolute top-[18%] right-[12%] h-[1rem] w-[1rem] rounded-full border-2
      border-[#3784fd] border-opacity-50'
              ></div>
              <div
                className='absolute bottom-[18%] left-[12%] h-[1rem] w-[1rem] rounded-full border-2
      border-[#3784fd] border-opacity-50'
              ></div>
            </>
          )}
        </div>
        <div
          className='border-card absolute right-0 left-0 bottom-[-1.7rem] z-10 mx-auto max-w-[90%] 
           rounded-[1rem] bg-white px-2 shadow-shadow1 sm:max-w-[75%] md:max-w-[50%] md:rounded-3 md:px-[1rem] xl:bottom-[-2.2rem] xl:rounded-[2rem] xl:px-4'
        >
          <Input
            name='searchKey'
            type='text'
            value={searchKey}
            onChange={handleChange}
            onClear={onClear}
            loading={loading}
            parentClassName='flex items-center'
            className='w-full py-[1.5rem] md:py-[1.5rem] xl:py-[2.4rem]'
            iconClassName='search text-[1.8rem] text-gray2'
            variant='unset'
            placeholder='Write a question or a problem'
          />
          {isOpenSearchList && (
            <div className='border-card absolute left-0 right-0 top-[110%] max-h-[20rem] w-full overflow-auto rounded-4 bg-white p-4'>
              {notEmpty(searchList) ? (
                searchList.map((item) => (
                  <div className='py-2 first-of-type:pt-0 last-of-type:pb-0'>
                    <Link href={'/help/' + item.id}>{item.title}</Link>
                  </div>
                ))
              ) : (
                <div className='flex h-full items-center justify-center'>
                  <p className='text-center'>
                    No results found for this search
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Banner;
